/**
 * Updates the global CSS variables that define the flavor colors
 * based on the provided trigger element's dataset attributes.
 *
 * @param {HTMLElement} trigger - The trigger element that contains the
 * color data in its dataset attributes. It should have the following
 * properties: 'data-color-light', 'data-color-medium', 'data-color-dark'.
 */
export const updateColors = (trigger) => {
  if (!trigger?.dataset?.colorLight) {
    return;
  }

  document.documentElement.style.setProperty(
    "--flavor-color-100",
    `${trigger.dataset.colorLight}`
  );
  document.documentElement.style.setProperty(
    "--flavor-color-200",
    `${trigger.dataset.colorMedium}`
  );
  document.documentElement.style.setProperty(
    "--flavor-color-300",
    `${trigger.dataset.colorDark}`
  );
  document.documentElement.style.setProperty(
    "--flavor-color-selector",
    `${trigger.dataset.colorSelector}`
  );
};

/**
 * Finds an element in the PDP markup that carries flavor theme data-color-* attrs.
 * @param {ParentNode} [root=document]
 * @returns {HTMLElement | null}
 */
export const findFlavorColorSource = (root = document) => {
  return (
    root.querySelector?.("details.product-flavor-dropdown[data-color-light]") ||
    root.querySelector?.(".product-swatch--active[data-color-light]") ||
    root.querySelector?.(".product-swatch--active") ||
    root.querySelector?.('a[aria-current="page"][data-color-light]') ||
    null
  );
};

/**
 * Syncs body/overlay flavor CSS variables from swapped Barba container markup.
 * @param {ParentNode} container
 * @param {{ overlayEl?: HTMLElement, waveEl?: HTMLElement }} [options]
 * @returns {boolean} whether colors were applied
 */
export const syncFlavorColorsFromContainer = (container, options = {}) => {
  const source = findFlavorColorSource(container);
  if (!source?.dataset?.colorLight) {
    return false;
  }

  updateColors(source);

  const { overlayEl, waveEl } = options;
  if (overlayEl) {
    overlayEl.style.background = source.dataset.colorLight;
  }
  if (waveEl) {
    waveEl.setAttribute("fill", `${source.dataset.colorLight}`);
  }

  return true;
};
